import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import noop from '../../utils/noop';
import AlternatePopoverContent from '../PopoverContent/AlternatePopoverContent';
import s from './BasicTooltip.scss';
/** This is basically a wrapper to keep this component working without updating all consumers for now
 * TODO: clean this shit up
 */
var BasicTooltip = React.forwardRef(function (_a, innerRef) {
    var wrapperClassName = _a.wrapperClassName, contentClassName = _a.contentClassName, withCloseButton = _a.withCloseButton, _b = _a.closeOnOutsideClick, closeOnOutsideClick = _b === void 0 ? true : _b, placement = _a.placement, children = _a.children, secondaryPlacement = _a.secondaryPlacement, _c = _a.onClose, onClose = _c === void 0 ? noop : _c;
    return (React.createElement(AlternatePopoverContent, { ref: innerRef, effectivePlacement: placement, effectiveSecondaryPlacement: secondaryPlacement, wrapperClassName: wrapperClassName, contentClassName: contentClassName, onClickOutside: closeOnOutsideClick ? onClose : undefined },
        children,
        withCloseButton && (React.createElement(PlainButtonOrLink, { className: s['close'], onClick: onClose },
            React.createElement(CloseBold, { size: IconSize.SMALLER, disableDefaultColors: true })))));
});
BasicTooltip.displayName = 'BasicTooltip';
export default BasicTooltip;
//# sourceMappingURL=BasicTooltip.js.map